/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { textAlignRight } from './style.js'
import React from 'react'
import { fmt, parseHtml } from '../../twd/all'

export const Header = ({detail,action}) => {
    return <React.Fragment>
        <div className="row vertical-offset-base"></div>
        <div className="row">
        <div className="col-md-3 col-xs-12 vertical-offset-sm">
            <div>Account</div>
            <div className="text-truncate"><b>{detail.accountNo} { parseHtml(detail.accountName) }</b></div>
        </div>
        <div className="col-md-6 col-xs-12"></div>
        <div className="col-md-3 col-xs-12 vertical-offset-sm" css={textAlignRight}>
            <div>Post trade purchasing power</div>
            <div className="text-bold">{fmt.money(detail.postPowerPurchasing)}</div>
        </div>
        </div>
        </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/orders/confirm/header.js